import { render, staticRenderFns } from "./ActiveOffers.vue?vue&type=template&id=3b27407a&"
import script from "./ActiveOffers.vue?vue&type=script&lang=js&"
export * from "./ActiveOffers.vue?vue&type=script&lang=js&"
import style0 from "./ActiveOffers.vue?vue&type=style&index=0&id=3b27407a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports